import React, {useEffect, useState} from 'react';
import {Col, Container, Row} from "reactstrap";
import LandingBanner from "../../../../components/LandingBanner/LandingBanner";
import "./ViberLayout.scss"
import FB from "../../../../assets/img/revamp/vibernets/icons8-facebook-48.png"
import YOUTUBE from "../../../../assets/img/revamp/vibernets/icons8-youtube-48.png"
import LINKEDIN from "../../../../assets/img/revamp/vibernets/icons8-linkedin-48.png"
import WHATSAPP from "../../../../assets/img/revamp/vibernets/icons8-whatsapp-48.png"
import WHY_US from "../../../../assets/img/revamp/vibernets/Why Us.jpg"
import InquiryForm from "../../../../components/InquiryForm/InquiryForm";
import webConfig from "../../../../config/WebConfig.json";
import FAQ from "../../../../components/FAQ/FAQ";
import CardsFooter from "../../../../components/Modals/Footers/CardsFooter";
import * as instituteService from "../../../../services/institute";
import CourseSlidesV2 from "../../../../components/CourseSlides/CourseSlidesV2";
import CourseSlides from "../../../../components/CourseSlides/CourseSlides";
import ViberHeader from "../../../../components/header-new/ViberHeader";
import VideoPlayerView from "../../../../components/YoutubePlayerViwe/VideoPlayerView";
import HowItsWork from "../../../../components/HowItsWork/HowItsWork";

export default function ViberLayout({children}) {

    const [teachers, setTeachers] = useState([])
    const [teacher, setTeacher] = useState({
        classes: [],
        teacherId: -1,
        courses: [],
        teacherName: "",
    })

    useEffect(() => {
        (async function () {

            const response = await instituteService.getInstituteTeachers();

            if (response && response.success && response.body.teachers) {
                const allTeachers = response.body.teachers;
                setTeachers(allTeachers)

                const teacherDetails = await instituteService.getTeacherDetails(allTeachers.length > 0 ? allTeachers[0].id : -1)

                if (teacherDetails && teacherDetails.success && teacherDetails.body) {
                    const body = teacherDetails.body

                    let data = {
                        classes: body.classes,
                        teacherId: body.id,
                        courses: body.courses,
                        teacherName: body.name
                    };
                    setTeacher(data);
                }
            }
        })()
    }, []);

    return (
        <Container fluid className={"p-0 viber-layout"}>

            <Row className={"no-gutters"}>
                <ViberHeader/>
            </Row>

            <Row className={"no-gutters"} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <Col md={11} xl={11} style={{paddingTop: 0}}>
                    <LandingBanner interval={20}/>
                </Col>
            </Row>

            <Row className={"no-gutters"} style={{
                marginTop: 60,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <Col xl={11} className={"p-0"}>
                    <Row className={"no-gutters"}>
                        <Col id={'aboutUsSection'} sm={12} md={12} xl={6} className={""}
                             style={{display: 'flex', paddingRight: 0, flexDirection: 'row', justifyContent: 'center'}}>
                            <img alt={"WHY_US"} className={"why-us-img"} src={WHY_US}/>
                        </Col>
                        <Col sm={12} md={12} xl={6} className={"why-us-col"}>
                            <div className={"why-us-topic font-gil"}>Why Us</div>
                            <div className={"text-start why-us-text-div"}>
                                <p className={"why-us-para"}>
                                    Vibernets academy is a leading network training provider in Sri Lanka incorporated
                                    in 2014.
                                    We established after having expertise experiences and knowledge on CCNA, CCNP, Linux
                                    &
                                    network
                                    security programmes for many years.
                                </p>
                                <p className={"why-us-para"}>
                                    Our mission,“We aim on making Network Specialists," drives
                                    us to deliver top-tier training
                                    in
                                    networking and IT. Trust Vibernets Academy for professional, hands-on training that
                                    empowers
                                    you
                                    to succeed in the competitive world of CCNA, CCNP certifications in Sri Lanka.
                                </p>
                            </div>
                            <div>
                                <h6 className={""} style={{
                                    color: 'black',
                                    padding: 0,
                                    paddingBottom: 5,
                                    margin: 0,
                                    fontWeight: 600,
                                    fontSize: 18
                                }}>Follow Us</h6>
                                <div style={{display: 'flex', flexDirection: 'row', gap: 10}}>
                                    <a target={"_blank"} href={"https://www.youtube.com/c/VibernetsStreaming"}>
                                        <img alt={"YOUTUBE"} className={"why-us-contact-img"} src={YOUTUBE}/></a>
                                    <a href={"https://www.facebook.com/vibernets"} target={"_blank"}>
                                        <img alt={"FB"} className={"why-us-contact-img"} src={FB}/></a>
                                    <a target={"_blank"} href={"https://wa.me/94702171111"}>
                                        <img alt={"WHATSAPP"} className={"why-us-contact-img"} src={WHATSAPP}/></a>
                                    <a target={"_blank"} href={"https://www.linkedin.com/company/vibernetsacademy/"}>
                                        <img alt={"LINKEDIN"} className={"why-us-contact-img"} src={LINKEDIN}/></a>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>


            {
                teacher && teacher.courses.length !== 0 ? <Row className={"no-gutters"} style={{paddingTop: 100}}>
                    <Col>
                        {
                            teacher && teacher.courses.length !== 0 &&
                            <section className="container class-section">
                                <div style={{
                                    textAlign: "center",
                                    color: "#090914",
                                    fontWeight: "bold",
                                    fontSize: 46,
                                    fontFamily: '"Gilroy Medium"'
                                }}>
                                    Our Courses
                                </div>
                                {/* <h3 className={"class-ctrl"}>Classes</h3> */}
                                <CourseSlidesV2 courses={teacher.courses} classesByLecture={[]}
                                                privileges={""}/>
                            </section>
                        }
                    </Col>
                </Row> : <></>
            }

            {
                teacher && teacher.classes.length !== 0 ? <Row className={"no-gutters"} style={{paddingTop: 100}}>
                    <Col>
                        {
                            teacher && teacher.classes.length !== 0 &&
                            <section className="container class-section">
                                <div style={{
                                    textAlign: "center",
                                    color: "#090914",
                                    fontWeight: "bold",
                                    fontSize: 46,
                                    fontFamily: '"Gilroy Medium"'
                                }}>
                                    Our Classes
                                </div>
                                {/* <h3 className={"class-ctrl"}>Classes</h3> */}
                                <CourseSlides classesByLecture={teacher.classes}
                                              privileges={""}/>
                            </section>
                        }
                    </Col>
                </Row> : <></>
            }

            <Row style={{marginTop: 30}} className={"no-gutters"}>
                <Col>
                    <VideoPlayerView landing youtubeLikes={webConfig.youtubeRefVideoLink}/>
                </Col>
            </Row>

            <Row style={{marginTop: 30}} className={"no-gutters"}>
                <Col>
                    <HowItsWork version={webConfig.layout} desc={webConfig.howItsWorkPara}/>
                </Col>
            </Row>

            <Row style={{marginTop: 30}} className={"no-gutters"}>
                <InquiryForm desc={webConfig.inquiryPara} descSin={webConfig.inquiryParaSin}/>
            </Row>

            <Row style={{marginTop: 30}} className={"no-gutters"}>
                <FAQ desc={webConfig.FAQDesc} descSin={webConfig.FAQSINDesc} faq={webConfig.faq}/>
            </Row>

            <Row style={{marginTop: 30}} className={"no-gutters border"}>
                <Col xl={12}>
                    <CardsFooter/>
                </Col>
            </Row>

        </Container>
    );
}